// src/helpers/dateFormat.js
//
// The `dates.*Format` translation values are moment.js format strings, not
// copy. Machine translation can turn tokens into other letters (Portuguese
// "YYYY" became "AAAA", which moment prints as "PMPMPMPM"). These formats show
// a date only, so accept just date tokens, separators and [bracketed] text.

export const DATE_FORMAT_KEYS = ['expiryFormat', 'prettyFormat']

export function isValidDateFormat(format) {
  if (typeof format !== 'string' || !format.trim()) return false
  const tokens = format.replace(/\[[^\]]*\]/g, '')
  return /^[MDYdoQwWLl\s.,/\-–—]*$/.test(tokens) && /[MDY]/.test(tokens)
}

/**
 * Replace invalid date formats in `messages` (merged bundled + Firestore) with
 * the shipped value from `bundled`, or drop them so vue-i18n falls back to English.
 */
export function guardDateFormats(messages, bundled) {
  const dates = messages && messages.dates
  if (!dates || typeof dates !== 'object') return messages
  for (const key of DATE_FORMAT_KEYS) {
    if (!(key in dates) || isValidDateFormat(dates[key])) continue
    const shipped = bundled && bundled.dates && bundled.dates[key]
    if (isValidDateFormat(shipped)) {
      dates[key] = shipped
    } else {
      delete dates[key]
    }
    console.warn(
      `[i18n] Ignoring invalid date format dates.${key}; using ${
        isValidDateFormat(shipped) ? `"${shipped}"` : 'the English format'
      }`
    )
  }
  return messages
}
